export const OpenedAgreementResources = {
	es: {
		['thanks_for_rent']: 'Gracias por tu renta',
		['go_get_your_car']: 'Ve por tu auto',
		['pickup_in_delivery_point']: 'Recoge en el punto de entrega',
		['pickup_in_delivery_point_desc']: 'Tu auto estará esperando por ti el día y la hora de tu renta. Un asesor de venta estará presente para entregártelo.',

		['show_your_qr_code']: 'Muestra el codigo QR al asesor',
		['show_your_qr_code_desc']: 'El código QR se encuentra en la página final de tu contrato.  este se ha enviado a tu whatsapp o correo electronico.',

		['get_your_key_and_go_ahead']: 'Recibe tu llave y ¡Listo!',

        ['additional']: 'Adicionales',
        ['additional_discount']: 'Descuento Adicionales',
        ['taxes']: 'Impuestos',

        ['total_cost']: 'Costo total',
	},
	en: {
		['thanks_for_rent']: 'Thanks for your rent',
		['go_get_your_car']: 'Go get your car',
		['pickup_in_delivery_point']: 'Pick up at the delivery point',
		['pickup_in_delivery_point_desc']: 'Your car will be waiting for you on the day and at the time of your rental. A sales agent will be there to hand over the keys.',

		['show_your_qr_code']: 'Show the QR code to the agent',
		['show_your_qr_code_desc']: 'The QR code is on the final page of your contract. It has been sent to your WhatsApp or email.',

		['get_your_key_and_go_ahead']: "Get your key, and you are good to go!",

        ['additional']: 'Additional',
        ['additional_discount']: 'Additional Discounts',
        ['taxes']: 'Taxes',

        ['total_cost']: 'Total cost',
	}
}
